// Electric Charge units with conversion factors to coulomb (C)
export const chargeUnits = [
  { id: 'coulomb', name: 'Coulomb', symbol: 'C', plural: 'Coulombs', factor: 1 },
  { id: 'megacoulomb', name: 'Megacoulomb', symbol: 'MC', plural: 'Megacoulombs', factor: 1e6 },
  { id: 'kilocoulomb', name: 'Kilocoulomb', symbol: 'kC', plural: 'Kilocoulombs', factor: 1e3 },
  { id: 'millicoulomb', name: 'Millicoulomb', symbol: 'mC', plural: 'Millicoulombs', factor: 1e-3 },
  { id: 'microcoulomb', name: 'Microcoulomb', symbol: 'µC', plural: 'Microcoulombs', factor: 1e-6 },
  { id: 'nanocoulomb', name: 'Nanocoulomb', symbol: 'nC', plural: 'Nanocoulombs', factor: 1e-9 },
  { id: 'picocoulomb', name: 'Picocoulomb', symbol: 'pC', plural: 'Picocoulombs', factor: 1e-12 },
  { id: 'abcoulomb', name: 'Abcoulomb', symbol: 'abC', plural: 'Abcoulombs', factor: 10 },
  { id: 'ampere-hour', name: 'Ampere-hour', symbol: 'Ah', plural: 'Ampere-hours', factor: 3600 },
  { id: 'milliampere-hour', name: 'Milliampere-hour', symbol: 'mAh', plural: 'Milliampere-hours', factor: 3.6 },
  { id: 'ampere-second', name: 'Ampere-second', symbol: 'As', plural: 'Ampere-seconds', factor: 1 },
  { id: 'faraday', name: 'Faraday', symbol: 'F', plural: 'Faradays', factor: 96485.33212 },
  { id: 'statcoulomb', name: 'Statcoulomb', symbol: 'statC', plural: 'Statcoulombs', factor: 3.335641e-10 },
  { id: 'elementary-charge', name: 'Elementary Charge', symbol: 'e', plural: 'Elementary Charges', factor: 1.602176634e-19 },
  { id: 'franklin', name: 'Franklin', symbol: 'Fr', plural: 'Franklins', factor: 3.335641e-10 },
];

export const popularChargeConversions = [
  { from: 'coulomb', to: 'ampere-hour' },
  { from: 'ampere-hour', to: 'coulomb' },
  { from: 'milliampere-hour', to: 'coulomb' },
  { from: 'coulomb', to: 'milliampere-hour' },
  { from: 'coulomb', to: 'microcoulomb' },
  { from: 'coulomb', to: 'faraday' },
];

export const getUnitById = (id) => chargeUnits.find(unit => unit.id === id);

export const convertCharge = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric charge units and learn the conversion formula.`;
};
